import React from 'react';
import { motion } from 'framer-motion';
export function Roadmap() {
  return <section className="py-24 border-b border-stone-300" data-id="element-1091">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1092">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1093">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1094">
            Roadmap
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-6 max-w-3xl" data-id="element-1095">
            From instant quotes to industry intelligence
          </h2>

          <p className="text-lg text-stone-600 leading-relaxed mb-16 max-w-2xl" data-id="element-1096">
            Own the pipe, own the data. BlockQuote builds the infrastructure
            today to power the intelligence layer of tomorrow.
          </p>

          {/* Timeline */}
          <div className="border border-stone-300" data-id="element-1097">
            <div className="grid grid-cols-1 md:grid-cols-4" data-id="element-1098">
              {/* MVP */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300 bg-stone-100" data-id="element-1099">
                <div className="flex items-center justify-between mb-4" data-id="element-1100">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-900 font-medium" data-id="element-1101">
                    MVP
                  </p>
                  <p className="font-mono text-xs text-red-600" data-id="element-1102">Now</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1103">
                  Instant Infrastructure
                </p>
                <p className="text-sm text-stone-600" data-id="element-1104">
                  Quotes, holds, proposals, basic workflow
                </p>
              </div>

              {/* V1 */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-1105">
                <div className="flex items-center justify-between mb-4" data-id="element-1106">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1107">
                    V1
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1108">Q2 2026</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1109">
                  Closing the Loop
                </p>
                <p className="text-sm text-stone-600" data-id="element-1110">
                  Contracts, e-sign, payments, PMS integrations
                </p>
              </div>

              {/* V2 */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-1111">
                <div className="flex items-center justify-between mb-4" data-id="element-1112">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1113">
                    V2
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1114">Q4 2026</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1115">Intelligence</p>
                <p className="text-sm text-stone-600" data-id="element-1116">
                  Benchmarking, probability scoring, forecasting
                </p>
              </div>

              {/* V3 */}
              <div className="p-6 border-l-2 border-l-red-600 md:border-l-0 md:border-t-2 md:border-t-red-600" data-id="element-1117">
                <div className="flex items-center justify-between mb-4" data-id="element-1118">
                  <p className="font-mono text-xs uppercase tracking-widest text-red-600 font-medium" data-id="element-1119">
                    V3
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1120">2027</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1121">Rate Brain</p>
                <p className="text-sm text-stone-600" data-id="element-1122">
                  Aggregation + intelligence platform
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}